import { injectable, inject, decorate } from 'inversify'
import { Api } from '@evertel/api'
import { SessionService } from '@evertel/session/SessionService'
import { makeAutoObservable, runInAction } from 'mobx'
import { APIDataDevice } from '@evertel/types'

export interface SoundOption {
    name: string
    file: string
    soundKey: string
    vibrate: number[]
}

class DeviceSettingsController {
    device: APIDataDevice = {}

    constructor(
        private api: Api,
        private sessionService: SessionService
    ) {
        makeAutoObservable(this)
    }

    fetchCurrentDevice = async () => {
        //this is NEVER triggered again so after a user logs in this won't be called?
        if (!this.sessionService.deviceId|| !this.sessionService.currentUserId) return

        const device = await this.api.Routes.BlueUser.getDevicesById(this.sessionService.currentUserId, this.sessionService.deviceId)

        runInAction(() => {
            this.device = device
        })
    }

    updateDeviceSettings = async (settings: any) => {
        const device = await this.api.Routes.BlueUser.putDevicesSettings(this.sessionService.currentUserId, this.sessionService.deviceId, settings)

        runInAction(() => {
            this.device = device
        })
    }

    getSoundOptions = (): SoundOption[] => {
        return [
            { name: 'Alien Calling', file: 'alien_calling.mp3', soundKey: 'alien_calling', vibrate: [500, 500, 500, 500, 500, 500, 500, 500, 500, 500] },
            { name: 'Angry Alarm', file: 'angry_alarm.mp3', soundKey: 'angry_alarm', vibrate: [500, 500, 500, 500, 500, 500, 500, 500, 500, 500] },
            { name: 'Annoy', file: 'annoy.mp3', soundKey: 'annoy', vibrate: [500, 500, 500, 500, 500, 500, 500, 500, 500, 500] },
            { name: 'Arrival', file: 'arrival.mp3', soundKey: 'arrival', vibrate: [300, 500, 300, 500] },
            { name: 'Battle Drums', file: 'battle_drums.mp3', soundKey: 'battle_drums', vibrate: [500, 500, 500, 500, 500, 500, 500, 500, 500, 500] },
            { name: 'Beepy', file: 'beepy.mp3', soundKey: 'beepy', vibrate: [500, 500, 500, 500] },
            { name: 'Boing', file: 'boing.mp3', soundKey: 'boing', vibrate: [300, 500, 300, 500] },
            { name: 'Bonus', file: 'bonus.mp3', soundKey: 'bonus', vibrate: [300, 500, 300, 500, 300, 500] },
            { name: 'Chime In', file: 'chime_in.mp3', soundKey: 'chime_in', vibrate: [500, 500, 500, 500] },
            { name: 'Dingy Dong', file: 'dingy_dong.mp3', soundKey: 'dingy_dong', vibrate: [500, 500, 500, 500] },
            { name: 'Hello', file: 'hello.mp3', soundKey: 'hello', vibrate: [300, 500, 300, 500] },
            { name: 'I\'m Here', file: 'im_here.mp3', soundKey: 'im_here', vibrate: [300, 500, 300, 500] },
            { name: 'Knock Knock Bells', file: 'knock_knock_bells.mp3', soundKey: 'knock_knock_bells', vibrate: [500, 500, 500, 500, 500, 500] },
            { name: 'Plinky', file: 'plinky.mp3', soundKey: 'plinky', vibrate: [300, 500, 300, 500] },
            { name: 'Ring', file: 'ring.mp3', soundKey: 'ring', vibrate: [500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500] },
            { name: 'Running Out', file: 'running_out.mp3', soundKey: 'running_out', vibrate: [500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500] },
            { name: 'Siren', file: 'siren.mp3', soundKey: 'siren', vibrate: [500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500] },
            { name: 'Success', file: 'success.mp3', soundKey: 'success', vibrate: [300, 500, 300, 500] },
            { name: 'Wake Up!', file: 'wake_up.mp3', soundKey: 'wake_up', vibrate: [500, 500, 500, 500] },
            { name: 'Water Alarm', file: 'water_alarm.mp3', soundKey: 'water_alarm', vibrate: [500, 500, 500, 500, 500, 500, 500, 500] },
            { name: 'Whoa!', file: 'whoa.mp3', soundKey: 'whoa', vibrate: [300, 500, 300, 500] },
            { name: 'Wow!', file: 'wow.mp3', soundKey: 'wow', vibrate: [300, 500, 300, 500] },
            { name: 'Zap', file: 'zap.mp3', soundKey: 'zap', vibrate: [500, 500, 500, 500] },
            { name: 'Zing', file: 'zing.mp3', soundKey: 'zing', vibrate: [500, 300, 500, 300, 500, 300] }

        ]
    }
}

decorate(injectable(), DeviceSettingsController)
decorate(inject(Api), DeviceSettingsController, 0)
decorate(inject(SessionService), DeviceSettingsController, 1)

export { DeviceSettingsController }
